import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { WINDOW } from '@ng-toolkit/universal';
import * as $ from 'jquery';
declare function ire(string,{}): any;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FAQComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    @Inject(WINDOW) private window: Window,
    ) { }

    ngOnInit() {
      this.titleService.setTitle('Trinka Help Center - FAQs');
      this.metaTagService.updateTag({ name: 'description', content: "Reveja as perguntas frequentes sobre a Trinka e resolva facilmente a maioria das dúvidas que você possa ter." });
      this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka Help Center - FAQs' });
      this.metaTagService.updateTag({ property: 'og:description', content: 'Reveja as perguntas frequentes sobre a Trinka e resolva facilmente a maioria das dúvidas que você possa ter.' });
      this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/pt/faqs' });
      this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
      this.metaTagService.updateTag({ name: 'language', content: 'pt-pt' });
      this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pt/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/faqs'});
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/faqs'});
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/faqs' });
      ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
    }
    gotoTop() {
      if (isPlatformBrowser(this.platformId)) {
        $.getScript('../../../assets/js/wisepop.js', function () { });
        this.window.scroll({
          top: 450,
          left: 0,
          behavior: 'smooth'
        });
      }
    }

    generateGuid() {
      var result, i, j;
      result = '';
      for(j=0; j<32; j++) {
        if( j == 8 || j == 12 || j == 16 || j == 20)
          result = result + '-';
        i = Math.floor(Math.random()*16).toString(16).toUpperCase();
        result = result + i;
      }
      return result;
    }

}
